import React, { useEffect, useState } from 'react';

import { Box, HStack } from '@chakra-ui/react';
import { map } from 'lodash';
import { useSelector } from 'react-redux';

import { cloudProviderOptionsWithAll } from 'components/DataDisplay';
import { BorderedBox } from 'components/DataDisplay/Box/BorderedBox';
import { FilterLabelWrapper } from 'components/DataDisplay/Box/BorderedBox/FilterLabelWrapper';
import { Select } from 'components/DataEntry';
import { useResourceType } from 'containers/App/hooks/useResourceType';
import { useRemediation } from 'containers/PolicyHub/Remediation/Components/hooks/useRemediation';
import { remediationTypeOptions } from 'containers/PolicyHub/Remediation/Components/utils';
import { selectRemediation } from 'containers/PolicyHub/Remediation/selector';
import { toTitleCase } from 'utils/string';

interface Props {
  resourceType: Record<string, any>;
  category: Record<string, any>;
  cloud: Record<string, any>;
  remediationType: Record<string, any>;
  categoryOptions: Record<string, any>[];
  updateValue(field: string, value: any);
}

export const RemediationFilters: React.FC<Props> = props => {
  const { remediationType, resourceType, cloud, updateValue, category } = props;
  const { remediationCategories } = useSelector(selectRemediation);
  const { resourceTypeAliasOptionsWithAll } = useResourceType();
  const [resourceTypeOptions, setResourceTypeOptions] = useState<
    Record<string, any>[]
  >([]);
  const [categoryOptions, setCategoryOptions] = useState<Record<string, any>[]>(
    [],
  );
  const { getRemediationCategories } = useRemediation();

  useEffect(() => {
    getRemediationCategories();
  }, [getRemediationCategories]);

  useEffect(() => {
    setCategoryOptions([
      { label: 'Alert Category', value: undefined },
      ...map(remediationCategories.data, o => ({
        label: toTitleCase(o?.category),
        value: o?.category,
      })),
    ]);
  }, [remediationCategories.data]);

  //set resource type options
  useEffect(() => {
    setResourceTypeOptions(resourceTypeAliasOptionsWithAll);
  }, [resourceTypeAliasOptionsWithAll, updateValue]);

  const styles = {
    menu: provided => ({
      ...provided,
      width: 'max-content',
      minWidth: '100%',
      //right: 0,
    }),
  };

  return (
    <BorderedBox>
      <HStack w="full" justify="space-between">
        <HStack>
          <FilterLabelWrapper>FILTER BY</FilterLabelWrapper>
          <Box>
            <Select
              options={cloudProviderOptionsWithAll}
              value={cloud}
              onChange={s => updateValue('cloud', s)}
              showIconInValueContainer
              menuPortalTarget={document.body}
              isAFilter
              leftMessage="Cloud"
              showUndefinedValueLabel={false}
            />
          </Box>
          <Box>
            <Select
              options={categoryOptions ?? []}
              value={category}
              onChange={s => updateValue('category', s)}
              showIconInValueContainer
              isLoading={remediationCategories.isLoading}
              menuPortalTarget={document.body}
              styles={styles}
              isAFilter
              leftMessage="Alert category"
              showUndefinedValueLabel={false}
            />
          </Box>
          <Box>
            <Select
              options={resourceTypeOptions}
              value={resourceType}
              onChange={s => updateValue('resourceType', s)}
              showIconInValueContainer
              menuPortalTarget={document.body}
              styles={styles}
              isAFilter
              leftMessage="Resource type"
              showUndefinedValueLabel={false}
            />
          </Box>
          <Box>
            <Select
              options={remediationTypeOptions}
              value={remediationType}
              onChange={s => updateValue('remediationType', s)}
              showIconInValueContainer
              menuPortalTarget={document.body}
              styles={styles}
              leftMessage="Type"
              isAFilter
              showUndefinedValueLabel={false}
            />
          </Box>
        </HStack>
      </HStack>
    </BorderedBox>
  );
};
